import { render } from "./ZamgPinCoord.vue?vue&type=template&id=0805a4b0&ts=true"
import script from "./ZamgPinCoord.vue?vue&type=script&lang=ts"
export * from "./ZamgPinCoord.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__